import { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getPersonById } from '@dealstack/frontend/app/services/Person.service.ts';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useMIPManageContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManageContext.ts';
import { useMipManageInvestorDetailBreadcrumbs } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/utils/mipManageBreadcrumbs.utils.ts';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

export const useInvestmentVehicleController = () => {
	const { dealId, mipId, personId } = useRequiredParams('dealId', 'mipId', 'personId');
	const tMipManage = useTranslationMipManage();
	const { mipData } = useMIPManageContext();

	useMipManageInvestorDetailBreadcrumbs({
		dealId,
		mipId,
		programmeName: mipData?.programmeName ?? '',
		leafName: tMipManage('investors.breadcrumbs.vehicles', { defaultValue: 'Vehicles' }),
		leafDataTestId: TEST_ELEMENT_IDS.MIP_MANAGE_INVESTMENT_VEHICLES_BREADCRUMB,
	});

	const vehicleQuery = useQuery({
		queryKey: [API_PATHS.PERSON_PERSONID_GET, { personId }],
		queryFn: ({ signal }) => getPersonById(API_PATHS.PERSON_PERSONID_GET, { personId }, signal),
	});

	const [isDetailsColumnCollapsed, setIsDetailsColumnCollapsed] = useState(false);
	const toggleDetailsColumn = useCallback(
		() => setIsDetailsColumnCollapsed((collapsed) => !collapsed),
		[]
	);

	const documentPersonIds = useMemo(() => [personId], [personId]);

	return {
		dealId,
		mipId,
		personId,
		documentPersonIds,
		vehicle: vehicleQuery.data,
		isLoading: vehicleQuery.isPending,
		isDetailsColumnCollapsed,
		toggleDetailsColumn,
	};
};
